import { render } from "./DataInfo.vue?vue&type=template&id=17ef2926"
import script from "./DataInfo.vue?vue&type=script&lang=js"
export * from "./DataInfo.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__